import script from "./EpisodesDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./EpisodesDropdown.vue?vue&type=script&setup=true&lang=js"

import "./EpisodesDropdown.vue?vue&type=style&index=0&id=5463b81e&lang=css"

const __exports__ = script;

export default __exports__